import { roles } from '../../constants/roles';

export const getTechnicalWarrantyOptions = (option, translations) => {
  switch (option) {
    case 'ACCEPTED':
      return [
        { value: 'MANUFACTURING', label: translations.MANUFACTURING },
        { value: 'DESIGN', label: translations.DESIGN },
        { value: 'VENDOR', label: translations.VENDOR },
        { value: 'PROCESS', label: translations.PROCESS },
        { value: 'INHOUSE_REPAIR', label: translations.INHOUSE_REPAIR },
        { value: 'SPARE_PART', label: translations.SPARE_PART },
        { value: 'FIELD_SERVICE_REPAIR', label: translations.FIELD_SERVICE_REPAIR },
        { value: 'REFURBISHED_MATERIAL', label: translations.REFURBISHED_MATERIAL },
      ];
    case 'DENIED':
      return [
        { value: 'NO_FAULT_FOUND', label: translations.NO_FAULT_FOUND },
        { value: 'WARRANTY_EXPIRED', label: translations.WARRANTY_EXPIRED },
        { value: 'CUSTOMER_FAULT', label: translations.CUSTOMER_FAULT },
        { value: 'OTHER', label: translations.OTHER },
      ];
    default:
      return [];
  }
};

export const getCommercialWarrantyOptions = (option, translations) => {
  switch (option) {
    case 'CONTRACTUAL_AGREEMENT':
      return [
        { value: 'EXTENDED_WARRANTY', label: translations.EXTENDED_WARRANTY },
        { value: 'SERVICE_CONTRACT', label: translations.SERVICE_CONTRACT },
      ];
    case 'GOODWILL_ACCEPTED':
      return [
        { value: 'Scientific Vacuum', label: translations.SCIENTIFIC },
        { value: 'Industrial Vacuum', label: translations.INDUSTRIAL },
        { value: 'Semiconductor Service', label: translations.SEMICONDUCTOR_SERVICE },
        { value: 'Vacuum Technique Service', label: translations.VACUUM_TECHNIQUE_SERVICE },
        { value: 'Semiconductor Chamber Solutions', label: translations.SEMICONDUCTOR_CHAMBER_SOLUTIONS },
        { value: 'Semi Abatement & integrated systems', label: translations.SEMI_ABATEMENT_AND_INTEGRATED_SYSTEMS },
        { value: 'Semi Advanced Chemical Management', label: translations.SEMI_ADVANCED_CHEMICAL_MANAGEMENT },
        { value: 'Service Cryogenics', label: translations.SERVICE_CRYOGENICS },
        { value: 'Semi Dry Pumps', label: translations.SEMI_DRY_PUMPS },
        { value: 'Industrial custom design', label: translations.INDUSTRIAL_CUSTOM_DESIGN },
        { value: 'Industrial Vacuum', label: translations.INDUSTRIAL_VACUUM },
        { value: 'Scientific custom design', label: translations.SCIENTIFIC_CUSTOM_DESIGN },
        { value: 'Semicon Turbo pumps', label: translations.SEMICON_TURBO_PUMPS },
        { value: 'Polycold', label: translations.POLYCOLD },
        { value: 'Scientific Cooling and Cryo', label: translations.SCIENTIFIC_CC },
        { value: 'Scientific Measurement and Instrumentation', label: translations.SCIENTIFIC_MI },
        { value: 'Scientific Vacuum Generation', label: translations.SCIENTIFIC_VG }
      ];
    case 'CHARGEABLE_TO_CUSTOMER':
    default:
      return [];
  }
};

export const isTechnicalDecisionDeclined = actions => actions.some(a => a.status === 'APPROVED' && a.decision === 'DENIED');

export const statusesThatCannotBeManuallySet = ['awaitingEquipment', 'jobReleased', 'productInvestigation', 'technicalAndCommercialDecision', 'finalReportReleased'];

export const getStatusOptions = (status, t) => {
  switch (status) {
    case 'equipmentReceivedWithDocumentation':
    case 'productEvaluation':
    case 'strippedAndDecontaminated':
    case 'builtAndTested':
    case 'shipped':
    case 'closed':
      return [{value: 'FULFILLED', label: t.done}, {value: 'UNFULFILLED', label: t.notDone}];
    default:
      return [{value: 'FULFILLED', label: t.done}, {value: 'UNFULFILLED', label: t.notDone}, {value: 'NOT_RELEVANT', label: t.notRelevant},];
  }
};

export const getReleaseMethodOptions = t => [
  { value: 'NO_TECHNICAL_TEAM_INVOLVEMENT', label: t.NO_TECHNICAL_TEAM_INVOLVEMENT},
  { value: 'GOLDENEYE_UPLINK', label: t.GOLDENEYE_UPLINK},
  { value: 'ON_SITE_PRESENCE', label: t.ON_SITE_PRESENCE},
  { value: 'RETURN_TO_PRODUCT_COMPANY', label: t.RETURN_TO_PRODUCT_COMPANY },
];

export const getReleaseMethodOptionsWithSendBackOption = t => [
  { value: 'NO_TECHNICAL_TEAM_INVOLVEMENT', label: t.NO_TECHNICAL_TEAM_INVOLVEMENT},
  { value: 'GOLDENEYE_UPLINK', label: t.GOLDENEYE_UPLINK},
  { value: 'ON_SITE_PRESENCE', label: t.ON_SITE_PRESENCE},
  { value: 'RETURN_TO_PRODUCT_COMPANY', label: t.RETURN_TO_PRODUCT_COMPANY },
  { value: 'SEND_BACK_PARTS', label: t.SEND_BACK_PARTS},
];

// Reclassify technical decision
export const reclassifiableCategories = [
  'MANUFACTURING',
  'VENDOR',
  'DESIGN',
  'PROCESS',
];

export const rolesThatCanReclassify = [
  roles.PRODUCT_COMPANY_TECHNICAL_SUPPORT_TEAM,
  roles.SERVICE_TECHNICAL_SUPPORT_TEAM,
  roles.SUPERADMIN,
];

export const getReclassifableTechnicalWarrantyOptions = translations => [
  { value: 'MANUFACTURING', label: translations.MANUFACTURING },
  { value: 'DESIGN', label: translations.DESIGN },
  { value: 'VENDOR', label: translations.VENDOR },
  { value: 'PROCESS', label: translations.PROCESS },
];

export const getWarrantyExpiredSubcategoryOptions = translations => [
  { value: 'OUT_OF_STANDARD_WARRANTY_PERIOD_-_NO_FAULT_FOUND', label: translations.WARRANTY_EXPIRED_NO_FAULT_FOUND },
  { value: 'OUT_OF_STANDARD_WARRANTY_PERIOD_-_CUSTOMER_FAULT', label: translations.WARRANTY_EXPIRED_CUSTOMER_FAULT },
  { value: 'OUT_OF_STANDARD_WARRANTY_PERIOD_-_OTHER', label: translations.WARRANTY_EXPIRED_OTHER },
  { value: 'OUT_OF_STANDARD_WARRANTY_PERIOD_-_COMPONENT_ISSUE', label: translations.WARRANTY_EXPIRED_COMPONENT_ISSUE },
];



// WEBPACK FOOTER //
// ./src/components/JobSummary/constants.js